import React, { useCallback, useEffect, useState } from 'react'
import { Alert, Button } from 'react-bootstrap'
import Progress from '../Form/Progress'
import styled from 'styled-components'
import { useAssetDataState } from '../../../stores/AssetDataProvider'
import { ButtonWithLoadingState } from '../../Buttons'
import { useTranslation, Trans } from 'react-i18next'

const StyledContainer = styled.div`
  @media screen and (min-width: 1081px) {
    position: sticky;
    top: 50px;
  }
`

const StyledCancelButton = styled(Button)`
  width: 100%;
  max-width: 250px;
`
const Sidebar = () => {

  const {
    submitEditAsset,
    errorsOccurredOnSubmit,
    formDataHasChanged,
    resetFormData,
    setSuccessSubmit,
    successSubmit
  } = useAssetDataState()

  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = useCallback(async e => {
    setSuccessSubmit(false)
    setIsLoading(true)
    formDataHasChanged && await submitEditAsset()
    setIsLoading(false)
  }, [formDataHasChanged, setSuccessSubmit, submitEditAsset])

  const handleClickCancel = () => {
    resetFormData();
  }

  //auto remove success message after couple sec.
  useEffect(() => {
    let timeout = null
    if (!isLoading && !!successSubmit) {
      timeout = setTimeout(() => {
        setSuccessSubmit(false)
      }, 3000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [isLoading, successSubmit, setSuccessSubmit])

  const { t } = useTranslation()

  return (
    <StyledContainer>
      <header>
        <div className="h2">{t('assetOverlayProgress:headerEdit')}</div>
      </header>
      <div className="content">
        <ButtonWithLoadingState
          className="submit-btn mb-3"
          isLoading={isLoading}
          onClick={handleSubmit}
          disabled={isLoading || !formDataHasChanged}
          buttonText={t('OverlayProgress:save')}
          loadingText={t('OverlayProgress:save')}
        />
        {formDataHasChanged && (
          <>
            <StyledCancelButton className="mb-3" variant="secondary" onClick={handleClickCancel}>{t('cancelButton')}</StyledCancelButton>
            <div className=" alert alert-info" >{t('EmployeeFormHealthData:dataChange')}</div>
          </>
        )}

        {(!isLoading && !!errorsOccurredOnSubmit) && (
          <Alert variant="danger">
            <Trans i18nKey='assetOverlayProgress:danger' />
          </Alert>
        )}
        {(!isLoading && !!successSubmit) && (
          <Alert variant="success">
            {t('assetOverlayProgress:success')}
          </Alert>
        )}
        <Progress />
      </div>
    </StyledContainer>
  )
}

export default Sidebar
